import React from 'react';
import { Campaign, CheckCircle, RefreshOutlined } from '@mui/icons-material';

import { Icons } from '../../Themes';
import CustomIcon from '../DesignSystem/CustomIcon';

export default function stepTabsIcon(state: any) {
  switch (state) {
    case 'ongoing':
    case 'current':
      return <RefreshOutlined />;
    case 'ended':
      return <CheckCircle />;
    case 'available':
      return <Campaign />;
    default:
      return <CustomIcon src={Icons.posts.phases.coming} color="currentColor" />;
  }
}
